import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CampaignState } from '../_shared/state/campaign.state';
import { AppState } from '../app.state';
@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss']
})
export class MarketingComponent implements OnInit {
  isValueTest: boolean;
  tabLabel: string;
  selectedTabIndex: number;
  onDestroyNotifier$ = new Subject();
  tabIndex: number;
  displayAutomatedRecommendations: boolean = true;

  constructor(public appState: AppState, private route: ActivatedRoute, public campaignState: CampaignState, private router: Router) { }

  ngOnInit(): void {
    if (this.appState?.appCompanyAliasValue == 'valuetest') {
      this.displayAutomatedRecommendations = false;
      this.tabLabel = 'Contact Lists';
    } else {
      this.tabLabel = 'My Contacts'
    }
    if (this.appState?.appCompanyAliasValue == 'opscan') {
      this.displayAutomatedRecommendations = false;
    }

    this.route.queryParamMap
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(params => {
        const tab = params.get('tab');
        this.selectTab(tab)
      });



  }
  selectTab(tabLabel) {

    if (tabLabel == 'campaigns') {
      this.selectedTabIndex = 0
    } else if (tabLabel == 'myContacts' || tabLabel == 'contactLists') {
      this.selectedTabIndex = 1
    } else if (tabLabel == 'marketingRecommendations') {
      this.selectedTabIndex = 2
    } else {
      this.selectedTabIndex = 0
    }

    return this.selectedTabIndex;
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
  updateUrl(tabName: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: tabName }
    });


  }
  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.ariaLabel === 'My Contacts') {
      this.updateUrl('myContacts');
    }
    if (event.tab.ariaLabel === 'campaigns') {
      this.updateUrl('campaigns');
    }
    if (event.tab.ariaLabel === 'Automated Recommendations') {
      this.updateUrl('marketingRecommendations');
    }
  }
}